import { AppContent, cn } from "twyne-new.ui";

export default function Sidebar({ children, size = '60', open, className }) {
  return <>
    <div className={cn(`w-${size} h-full z-10 relative`, open ? 'block' : 'hidden', className)}>
      <div className="w-full h-full twy-bg-base p-2">
        <div className='w-full h-full twy-bg-base-accent rounded-xs p-2'>
          <div className='flex h-full'>
            <AppContent>
              {children}
            </AppContent>
          </div>
        </div>
      </div>
    </div>
  </>
}
